/**
 * @generated SignedSource<<dd8996647b8d1606f7eb4bcd6d9b2240>>
 * @relayHash a08c28c00228cd2e0fe06f38109c1b69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 23013202ed01879c7c92df6cce5acc59604a332d33236339a5a83172ed8b4ebe

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TopNavigationQuery$variables = {
  appSwitcherProductAri: string;
  atlassianAccountId: string;
  cloudId: string;
  collabContextRoutingAri?: string | null;
  isAnonymous: boolean;
  issueKey: string;
  projectIdOrKey: string;
  projectKey: string;
  shouldCheckProjectType: boolean;
  shouldCheckProjectTypeForIssue: boolean;
  shouldFetchCSMLiveChatAgent: boolean;
  shouldFetchProjectFavicon: boolean;
  shouldFetchProjectType: boolean;
  shouldFetchProjectTypeForSettingsAndEA: boolean;
  skipAppSwitcherUnitProfile: boolean;
  skipEditionAwarenessFragment: boolean;
  skipHelpButtonRelayRead: boolean;
};
export type TopNavigationQuery$data = {
  readonly appSwitcher_unitProfile?: {
    readonly __typename: "AppSwitcherUnitProfile";
    readonly unitIconUrl: string | null;
    readonly unitName: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly editionAwareness?: {
    readonly " $fragmentSpreads": FragmentRefs<"EditionAwareness_query">;
  } | null;
  readonly helpButton?: {
    readonly " $fragmentSpreads": FragmentRefs<"HelpButton_query">;
  } | null;
  readonly notifications?: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4NotificationsData">;
  } | null;
  readonly profile?: {
    readonly " $fragmentSpreads": FragmentRefs<"ProfileNew">;
  } | null;
  readonly projectFavicon?: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectFaviconService_query">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductHomeWithQuery" | "SettingsAction_query" | "SettingsSlot_query">;
};
export type TopNavigationQuery = {
  response: TopNavigationQuery$data;
  variables: TopNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appSwitcherProductAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextRoutingAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectType"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectTypeForIssue"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchCSMLiveChatAgent"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectFavicon"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectType"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectTypeForSettingsAndEA"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAppSwitcherUnitProfile"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipEditionAwarenessFragment"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipHelpButtonRelayRead"
},
v17 = [
  {
    "kind": "Variable",
    "name": "collabContextRoutingAri",
    "variableName": "collabContextRoutingAri"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = {
  "condition": "skipAppSwitcherUnitProfile",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "productAri",
          "variableName": "appSwitcherProductAri"
        }
      ],
      "kind": "LinkedField",
      "name": "appSwitcher_unitProfile",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "unitName"
            },
            {
              "kind": "ScalarField",
              "name": "unitIconUrl"
            }
          ],
          "type": "AppSwitcherUnitProfile"
        }
      ]
    }
  ]
},
v20 = {
  "kind": "Variable",
  "name": "accountId",
  "variableName": "atlassianAccountId"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v23 = [
  (v22/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v24 = [
  {
    "kind": "ScalarField",
    "name": "projectType"
  },
  (v21/*: any*/)
],
v25 = [
  {
    "args": (v23/*: any*/),
    "concreteType": "JiraProject",
    "kind": "LinkedField",
    "name": "jira_projectByIdOrKey",
    "plural": false,
    "selections": (v24/*: any*/)
  }
],
v26 = {
  "condition": "shouldFetchProjectTypeForSettingsAndEA",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v25/*: any*/)
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TopNavigationQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProfileNew"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "profile"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v17/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "Nav4NotificationsData"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "notifications"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "ProductHomeWithQuery"
      },
      {
        "condition": "skipEditionAwarenessFragment",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "EditionAwareness_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "editionAwareness"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "SettingsAction_query"
      },
      {
        "kind": "FragmentSpread",
        "name": "SettingsSlot_query"
      },
      {
        "condition": "skipHelpButtonRelayRead",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "HelpButton_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "helpButton"
          }
        ]
      },
      {
        "condition": "shouldFetchProjectFavicon",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectFaviconService_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "projectFavicon"
          }
        ]
      },
      (v19/*: any*/)
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopNavigationQuery",
    "selections": [
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              (v20/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              (v21/*: any*/)
            ]
          },
          {
            "condition": "shouldFetchProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v25/*: any*/)
          },
          {
            "condition": "shouldFetchCSMLiveChatAgent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v20/*: any*/),
                  (v22/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "csm_liveChatAgent",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v21/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "liveChatActivity"
                      },
                      {
                        "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                        "kind": "LinkedField",
                        "name": "liveChatActivitiesBySpace",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "activityStatus"
                                  },
                                  (v21/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CustomerServiceLiveChatAgent"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "identifier"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "message"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "statusCode"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "errorType"
                          }
                        ]
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "InfluentsNotificationQuery",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": [
              {
                "args": (v17/*: any*/),
                "kind": "ScalarField",
                "name": "unseenNotificationCount"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldCheckProjectTypeForIssue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v22/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": (v24/*: any*/)
                      },
                      (v21/*: any*/)
                    ]
                  },
                  (v21/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldCheckProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v22/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "projectKey"
                  }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": (v24/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "skipEditionAwarenessFragment",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v26/*: any*/)
        ]
      },
      (v26/*: any*/),
      {
        "condition": "skipHelpButtonRelayRead",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v22/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "propertyKey",
                    "value": "help_button_ui_state"
                  }
                ],
                "concreteType": "JiraEntityPropertyJSON",
                "kind": "LinkedField",
                "name": "jsonUserProperty",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jsonValue"
                  },
                  (v21/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldFetchProjectFavicon",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v23/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "medium"
                  }
                ]
              },
              (v21/*: any*/)
            ]
          }
        ]
      },
      (v19/*: any*/)
    ]
  },
  "params": {
    "id": "23013202ed01879c7c92df6cce5acc59604a332d33236339a5a83172ed8b4ebe",
    "metadata": {},
    "name": "TopNavigationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "13dcc01719f2e3d5e5e0c1ee0fad7f40";

export default node;
